import React from 'react'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'

const TableBodyEmpty = ({ id, colSpan, labelNoRows }) => {
  return (
    <TableBody key={`table-body-empty-${id}`}>
      <TableRow>
        <TableCell colSpan={colSpan} className="text-center">
          <Typography color='inherit' component={'p'} className='text-muted-foreground opacity-50 py-2 text-center'>{labelNoRows}</Typography>
        </TableCell>
      </TableRow>
    </TableBody>
  )
}

export default TableBodyEmpty